import React, { useState, useRef } from "react";
import html2canvas from "html2canvas";

const SnipTool: React.FC = () => {
  const [isSnipping, setIsSnipping] = useState(false);
  const [startPos, setStartPos] = useState<{ x: number; y: number } | null>(null);
  const [endPos, setEndPos] = useState<{ x: number; y: number } | null>(null);
  const snipRef = useRef<HTMLDivElement>(null);

  const handleMouseDown = (e: React.MouseEvent) => {
    setStartPos({ x: e.clientX, y: e.clientY });
    setEndPos(null);
  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (!startPos) return;
    setEndPos({ x: e.clientX, y: e.clientY });
  };

  const handleMouseUp = async () => {
    if (!startPos || !endPos) return;
    const x = Math.min(startPos.x, endPos.x);
    const y = Math.min(startPos.y, endPos.y);
    const width = Math.abs(startPos.x - endPos.x);
    const height = Math.abs(startPos.y - endPos.y);

    const canvas = await html2canvas(document.body);
    const croppedCanvas = document.createElement("canvas");
    croppedCanvas.width = width;
    croppedCanvas.height = height;
    const ctx = croppedCanvas.getContext("2d");
    if (ctx) {
      ctx.drawImage(canvas, x, y, width, height, 0, 0, width, height);
      const dataUrl = croppedCanvas.toDataURL("image/png");

      // Download the selected snippet
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "snip.png";
      link.click();
    }

    setIsSnipping(false);
    setStartPos(null);
    setEndPos(null);
  };

  return (
    <div>
      <button onClick={() => setIsSnipping(true)}>Start Snipping</button>
      -------sd---------------------------------------fsdf----------<br />
      -------------asds-ad-----------------------sdfsd-------------------<br />
      ---------dasd-------asdas-----------sdf-dsf---------sdf-------------------<br />
      -------------------------das-----sdf-------------------sdf-------<br />
      -------------------dsfsd---------dasasdd------------------dsf----------<br />
      ----------------fdf--------------sdf-sdf--------sdfsf-----------------<br />
      {isSnipping && (
        <div
          ref={snipRef}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            cursor: "crosshair",
            zIndex: 9999,
          }}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
        >
          {startPos && endPos && (
            <div
              style={{
                position: "absolute",
                left: Math.min(startPos.x - 1, endPos.x - 1),
                top: Math.min(startPos.y - 1, endPos.y - 1),
                width: Math.abs(startPos.x - endPos.x - 2),
                height: Math.abs(startPos.y - endPos.y - 2),
                border: "1px dashed red",
                backgroundColor: "rgba(255,255,255,0)",
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default SnipTool;
